export class RetailStoreCommonConstants {
  static readonly RETAILHQ_VALUE = $localize`:@@retail-store.dropdown.retail-hq:Retail HQ`;
  static readonly STORE_VALUE = $localize`:@@retail-store.dropdown.store:Store`;
  static readonly DESCENDING_ORDER = 'desc';
  static readonly ASCENDING_ORDER = 'asc';
  static readonly DEVICE_EXECUTIVE_VALUE = $localize`:@@retail-store.dropdown.device-executive:Device Executive`;
}
